import { post } from "app/popleads/networking/RequestService";
import { toast } from "react-toastify";
import { useExtensionContext } from "../modules/extension/ExtensionContext";
import { useState } from "react";

const useEtiketSil = () => {
    const { refetchProfile } = useExtensionContext();
    const [etiketSilLoading, setEtiketSilLoading] = useState(false);

    const etiketSil = async ({ profil, etiket }) => {
        try {
            setEtiketSilLoading(true);
            const response = await post({
                fn: "etiketSil",
                profil,
                etiket,
            });

            if (response?.data?.stat === "ok") {
                toast.success("Campaign deleted successfully");
                refetchProfile();
            }
        } catch (error) {
            toast.error(error?.response?.data?.text);
            setEtiketSilLoading(false);
            return { success: false, error: error.message };
        } finally {
            setEtiketSilLoading(false);
        }
    };

    return { etiketSil, etiketSilLoading };
};

export default useEtiketSil;
